export default "__VITE_ASSET__DkGkSqmg__"